import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import EventEmitter, {
  SHOW_POPUP_BUY_REPORT,
  SHOW_POPUP_UPGRADE,
} from '../../helpers/EventEmitter'
import { getUnique } from '../../helpers/common'
import { getFontSize } from '../../helpers/fontSize'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../utils/authorization'
import useCompanyHeader from '../category/useCompanyHeader'
import { UseI18n } from '../hooks/useI18n'
import { useLogo } from '../hooks/useLogo'
import { UseTimeZone } from '../hooks/useTimeZone'
import { UseTypeFontSize } from '../hooks/useTypeFontSize'
import { Icon } from '../html/icon'
import { exportToImg, handleNameFileDownload } from './helper'
import './i18n'

export const DownloadJpg = ({ data, children }) => {
  const { domId, arrName, titleJpg, DownloadComponent, disabled, isFixSvg } =
    data

  const location = useLocation()
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)
  const { companyHeader } = useCompanyHeader({ disableCallApi: true })
  const logo = useLogo()

  const timezone = UseTimeZone()
  const typeFontSize = UseTypeFontSize()

  const fontSizeTitle = getFontSize(14, typeFontSize)
  const fontSizeSource = getFontSize(12, typeFontSize)
  const source = UseI18n('common.downloadJpg.FOOTER')

  const portalId = useRef(getUnique())

  const [container] = useState(() => {
    const containerEl = document.createElement('div')
    const pxOutOfScreen = '-100000px'
    containerEl.id = portalId.current
    containerEl.style.position = 'absolute'
    containerEl.style.left = pxOutOfScreen
    containerEl.style.top = pxOutOfScreen

    document.body.appendChild(containerEl)
    return containerEl
  })

  useEffect(() => {
    return () => document.body.removeChild(container)
  }, [])

  const saveImageStockChart = () => {
    if (location.pathname.includes('/companyAnalysis')) {
      companyAnalysisAction()
    } else {
      otherAction()
    }
  }

  const companyAnalysisAction = () => {
    if (
      AUTHORIZATION_API.companyAnalysis.downloadPanel[userType.userTypeId] ===
      AUTHORIZATION_TYPE.ALLOW
    ) {
      if (companyHeader.allowDynamicReport) {
        downloadAction()
      } else {
        EventEmitter.dispatch(SHOW_POPUP_BUY_REPORT)
      }
    } else if (
      AUTHORIZATION_API.companyAnalysis.downloadPanel[userType.userTypeId] ===
      AUTHORIZATION_TYPE.DISABLE
    ) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  const otherAction = () => {
    downloadAction()
  }

  const downloadAction = () => {
    if (!disabled) {
      exportToImg(
        logo,
        DownloadComponent ? portalId.current : domId,
        `${handleNameFileDownload(arrName, timezone)}.jpg`,
        titleJpg,
        source,
        fontSizeTitle,
        fontSizeSource,
        isFixSvg,
      )
    }
  }

  if (children) {
    return <span onClick={saveImageStockChart}>{children}</span>
  }

  return (
    <>
      <Icon
        onClick={saveImageStockChart}
        className="icon-download"
        style={{ color: disabled ? '#9C9C9C' : '#0553A5', fontSize: 16 }}
      />
      {DownloadComponent && createPortal(DownloadComponent, container)}
    </>
  )
}

DownloadJpg.propTypes = {
  data: PropTypes.shape({
    domId: PropTypes.string,
    arrName: PropTypes.array.isRequired,
    titleJpg: PropTypes.string,
    DownloadComponent: PropTypes.node,
    disabled: PropTypes.bool,
    isFixSvg: PropTypes.bool,
  }).isRequired,
}
